import React from "react";
import { Card } from "@/CommonElements/Hajj/Card";
import { useTranslation } from "react-i18next";
import { STACK_4 } from "./PilgrimDetails";
import  { LabelValue } from "@Component/Value"

export const PilgrimMadinaData = (props) => {
  const { t } = useTranslation();
  const { isLoading } = props;

  const {
    service_center_number_madinah,
    accommodation_address_madinah,
    locker_number_madinah,
    arrival_date_madinah,
    preliminary_departure_report_number_madinah,
  } = props;

  const VerticalLabelValue = (props) => (
    <LabelValue loading={isLoading} direction="vertical" {...props} />
  );

  return (
    <Card header={<span className="H5">{t("PILGRIM_DATA_MADINAH")}</span>}>
      <STACK_4>
        <VerticalLabelValue
          copyValue={service_center_number_madinah}
          label={t("SERVICE_CENTER_NUMBER_MADINAH")}
          value={service_center_number_madinah || "-"}
        />
        <VerticalLabelValue
          label={t("ACCOMMODATION_ADDRESS_MADINAH")}
          value={accommodation_address_madinah || "-"}
        />
        <VerticalLabelValue
          copyValue={locker_number_madinah}
          label={t("LOCKER_NUMBER_MADINAH")}
          value={locker_number_madinah || "-"}
        />
        <VerticalLabelValue
          label={t("ARRIVAL_DATE")}
          value={arrival_date_madinah || "-"}
        />
        <VerticalLabelValue
          label={t("PRELIMINARY_DEPARTURE_REPORT_NUMBER")}
          value={preliminary_departure_report_number_madinah || "-"}
        />
      </STACK_4>
    </Card>
  );
};
